var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "form-group" }, [
    _c(
      "label",
      { staticClass: "form-label", class: { required: _vm.required } },
      [_vm._v(_vm._s(_vm.label))]
    ),
    _vm._v(" "),
    _c("div", { staticClass: "gender custom-radio" }, [
      _vm.placeholder && _vm.modelValue == null
        ? _c("span", { staticClass: "text-muted" }, [
            _vm._v(_vm._s(_vm.placeholder)),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "flex radio-group" },
        _vm._l(_vm.options, function (option) {
          return _c(
            "div",
            {
              key: option[_vm.optionValue],
              staticClass: "form-check form-check-inline",
            },
            [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.internalValue,
                    expression: "internalValue",
                  },
                ],
                staticClass: "form-check-input",
                attrs: {
                  type: "radio",
                  id: `${_vm.name}-${option[_vm.optionValue]}`,
                  name: _vm.name,
                  disabled: _vm.disabled,
                  required: _vm.required,
                },
                domProps: {
                  value: option[_vm.optionValue],
                  checked: _vm._q(_vm.internalValue, option[_vm.optionValue]),
                },
                on: {
                  change: function ($event) {
                    _vm.internalValue = option[_vm.optionValue]
                  },
                },
              }),
              _vm._v(" "),
              _c(
                "label",
                {
                  staticClass: "form-check-label",
                  staticStyle: { margin: "10px" },
                  attrs: { for: `${_vm.name}-${option[_vm.optionValue]}` },
                },
                [
                  _vm._v(
                    "\n          " +
                      _vm._s(option[_vm.optionLabel]) +
                      "\n        "
                  ),
                ]
              ),
            ]
          )
        }),
        0
      ),
    ]),
    _vm._v(" "),
    _vm.error
      ? _c("small", { staticClass: "text-danger" }, [_vm._v(_vm._s(_vm.error))])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }